import type { ComponentProps, FC } from 'react';

import { Divider, Skeleton } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = ComponentProps<'div'>;

const ApprovalSequenceSkeleton: FC<Props> = (props) => {
  return (
    <div {...props} className={cn('grid gap-4', props.className)}>
      <Skeleton className="h-12 w-full" variant="rounded" />
      <div className="flex items-center gap-2">
        <div className="grow">
          <Divider orientation="horizontal" />
        </div>
        <Skeleton className="h-4 w-full max-w-21" variant="rounded" />
        <div className="grow">
          <Divider orientation="horizontal" />
        </div>
      </div>
      <Skeleton className="h-12 w-full" variant="rounded" />
    </div>
  );
};

export default ApprovalSequenceSkeleton;
